/**
 * Scroll to top of window
 */
const scrollToTop = () => window.scrollTo(0, 0);

/**
 * Scroll to hash in URL, or top of window if it doesn't exist
 */
const scrollToHash = () =>
  (
    document.getElementById(window.location.hash.slice(1)) || document.body
  ).scrollIntoView();

/**
 * Check if an element is visible within the viewport
 */
const isInViewport = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export { isInViewport, scrollToHash, scrollToTop };
